import { render } from "./PriceEditModal.vue?vue&type=template&id=41ced22c"
import script from "./PriceEditModal.vue?vue&type=script&lang=js"
export * from "./PriceEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__